module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"all":"전체","range":{"over":"{value} {unit} 이상","under":"{value} {unit} 이하","between":"{start} - {end} {unit}"}}}')
  delete Component.options._Ctor
}
